import congratulationsIcon from 'src/public/img/illustration-agreement.svg';
import weekIcon from 'src/public/img/illustration-education.svg';

import { FeedbackStep } from 'src/modules/programs/feedback/stepComponents/FeedbackStep';
import { ProgramSharedStep, ProgramWeekEnum } from 'src/modules/programs/models/programs';

import { CBTProgramStepProps } from '../../models/cbtProgram';
import { ExposuresCompletionStep } from '../stepComponents/ExposuresCompletionStep';
import { NowWhatStep } from '../stepComponents/NowWhatStep';
import { PuttingItAllTogetherStep } from '../stepComponents/PuttingItAllTogetherStep';
import { ThankYouStep } from '../stepComponents/ThankYouStep';
import { WaysToFitTogetherStep } from '../stepComponents/WaysToFitTogetherStep';
import { CBTProgramWeekEightStep } from './weekEight';

const steps: (ProgramSharedStep | CBTProgramWeekEightStep)[] = [
    ProgramSharedStep.WellbeingCheckInStep,
    ProgramSharedStep.WellbeingScoreStep,
    ProgramSharedStep.FeedbackStep,
    CBTProgramWeekEightStep.ExposuresCompletionStep,
    CBTProgramWeekEightStep.PuttingItAllTogetherStep,
    CBTProgramWeekEightStep.WaysToFitTogetherStep,
    CBTProgramWeekEightStep.NowWhatStep,
    ProgramSharedStep.ProgramFeedbackStep,
    CBTProgramWeekEightStep.ThankYouStep,
];

const stepsProps: CBTProgramStepProps[] = [
    {
        id: CBTProgramWeekEightStep.ExposuresCompletionStep,
        component: ExposuresCompletionStep,
        tooltip: 'Complete exposures',
        noButtons: true,
    },
    {
        id: CBTProgramWeekEightStep.PuttingItAllTogetherStep,
        component: PuttingItAllTogetherStep,
        tooltip: 'Putting it all togoether',
    },
    {
        id: CBTProgramWeekEightStep.WaysToFitTogetherStep,
        component: WaysToFitTogetherStep,
        tooltip: 'Ways to fit it together',
    },
    {
        id: CBTProgramWeekEightStep.NowWhatStep,
        component: NowWhatStep,
        tooltip: 'Now what?',
    },
    {
        id: ProgramSharedStep.ProgramFeedbackStep,
        component: FeedbackStep,
        tooltip: 'Program Feedback',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: CBTProgramWeekEightStep.ThankYouStep,
        component: ThankYouStep,
        tooltip: 'Congratulations',
        flexGrow: false,
    },
];

const t = (key: string) => `cbt:week-8.data.${key}`;

export const weekEightData = {
    id: ProgramWeekEnum.WeekEight,
    weekNumber: 7,
    readableWeekNumber: 8,
    iconUrl: weekIcon,
    congratulationsIconUrl: congratulationsIcon,
    title: t('title'),
    congratulationsSneakPeek: t('congratulationsSneakPeek'),
    feedbackPlaceholder: t('feedbackPlaceholder'),
    greetingModalContent: t('greetingModalContent'),
    steps,
    stepsProps,
};
